export const actions = {
    addItem({ commit }, item) {
      commit('ADD_ITEM', item);  // Commit the mutation to add the item
    },
    removeItem({ commit }, itemId) {
      commit('REMOVE_ITEM', itemId);
    },
    clearCart({ commit }) {
      commit('CLEAR_CART');
    }
  };